export default __webpack_public_path__ + "static/media/StepsActive02.c8cc5620.svg";